export const detectAppleDevice = () => {
  const isApple = {
    device: /iphone|ipad|ipod|macintosh|mac os x/.test(navigator.userAgent.toLowerCase()),
    platform:
      navigator.platform.toLowerCase().startsWith('mac') ||
      navigator.platform.toLowerCase().startsWith('iphone') ||
      navigator.platform.toLowerCase().startsWith('ipad'),
    vendor: navigator.vendor.includes('Apple'),
  };

  return isApple.device || isApple.platform || isApple.vendor;
};
